import { call, put } from "redux-saga/effects";
import { fetchOrderByOrderNumber } from "../requests/trackOrder";
import {
  fetchOrderByOrderNumberSuccess,
  fetchOrderByOrderNumberFailure,
} from "../../trackOrder/trackOrderAction";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";

export function* handleTrackOrder({ payload: { orderNumber, lang } }) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(fetchOrderByOrderNumber, { orderNumber, lang });
    const { order } = parseOrderData(response);
    if (!order) {
      yield put(fetchOrderByOrderNumberFailure({ error: { message: "" } }));
    }else{
      yield put(fetchOrderByOrderNumberSuccess({ order }));
    }
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleTrackOrder error = ${error}`);
    yield put(fetchOrderByOrderNumberFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseOrderData = (response) => ({
  order: response?.data?.erp_status,
});
